module.exports = __webpack_public_path__ + "img/icon-ultima-farm.805c060a.svg";